<div class="form">
  <h1 class="page-title">Create A User</h1>

  <form [formGroup]="userForm" (ngSubmit)="createUser()" novalidate>
    <h3 class="section-title color-default">Basic Information</h3>
    <div class="form-group">
      <label>Title</label>
      <select class="form-control" formControlName="title">
        <option value="">Select title</option>
        @for (userTitle of userTitles; track userTitle) {
          <option [value]="userTitle">{{userTitle}}</option>
        }
      </select>
      @if (userForm.get('title')?.errors && userForm.get('title')?.touched) {
        <div class="text-danger">
          @if (userForm.get('title')?.hasError('required')) {
            <div>Title is required</div>
          }
        </div>
      }
    </div>

    <!-- First Name -->
    <div class="form-group">
      <label>First Name</label>
      <input class="form-control" type="text" formControlName="firstname">
      @if (userForm.get('firstname')?.errors && userForm.get('firstname')?.touched) {
        <div class="text-danger">
          @if (userForm.get('firstname')?.hasError('required')) {
            <div>First Name is required</div>
          }
        </div>
      }
    </div>

    <!-- Last Name -->
    <div class="form-group">
      <label>Last Name</label>
      <input class="form-control" type="text" formControlName="lastname">
      @if (userForm.get('lastname')?.errors && userForm.get('lastname')?.touched) {
        <div class="text-danger">
          @if (userForm.get('lastname')?.hasError('required')) {
            <div>Last Name is required</div>
          }
        </div>
      }
    </div>

    <!-- Initials -->
    <div class="form-group">
      <label>Initials</label>
      <input class="form-control" type="text" formControlName="initials">
      @if (userForm.get('initials')?.errors && userForm.get('initials')?.touched) {
        <div class="text-danger">
          @if (userForm.get('initials')?.hasError('required')) {
            <div>Initials are required</div>
          }
        </div>
      }
    </div>

    <!-- Email -->
    <div class="form-group">
      <label>Email</label>
      <input class="form-control" type="email" formControlName="email">
      @if (userForm.get('email')?.errors && userForm.get('email')?.touched) {
        <div class="text-danger">
          @if (userForm.get('email')?.hasError('required')) {
            <div>Email is required</div>
          }
          @if (userForm.get('email')?.hasError('email')) {
            <div>Invalid email format</div>
          }
        </div>
      }
    </div>

    <!-- Credentials -->
    <div class="form-group">
      <label>Credentials</label>
      <input class="form-control" type="text" formControlName="credentials">
      @if (userForm.get('credentials')?.errors && userForm.get('credentials')?.touched) {
        <div class="text-danger">
          @if (userForm.get('credentials')?.hasError('required')) {
            <div>Credentials is required</div>
          }
        </div>
      }
    </div>

    <!-- Password -->
    <div class="form-group">
      <label>Password</label>
      <input class="form-control" type="password" formControlName="password">
      @if (userForm.get('password')?.errors && userForm.get('password')?.touched) {
        <div class="text-danger">
          @if (userForm.get('password')?.hasError('required')) {
            <div>Password is required</div>
          }
        </div>
      }
    </div>

    <!-- Date of Birth -->
    <div class="form-group">
      <label>Date of Birth</label>
      <input class="form-control" type="date" formControlName="dob">
      @if (userForm.get('dob')?.errors && userForm.get('dob')?.touched) {
        <div class="text-danger">
          @if (userForm.get('dob')?.hasError('required')) {
            <div>Date of Birth is required</div>
          }
        </div>
      }
    </div>

    <!-- Gender -->
    <div class="form-group">
      <label>Gender</label>
      <select class="form-control" formControlName="gender">
        <option value="">Select gender</option>
        @for (gender of genders; track gender) {
          <option [value]="gender">{{ gender }}</option>
        }
      </select>
      @if (userForm.get('gender')?.errors && userForm.get('gender')?.touched) {
        <div class="text-danger">
          @if (userForm.get('gender')?.hasError('required')) {
            <div>Gender is required</div>
          }
        </div>
      }
    </div>

    <!-- Security Question -->
    <div class="form-group" formGroupName="security">
      <label>Security Question</label>
      <input class="form-control" type="text" formControlName="question">
      @if (userForm.get('security')?.get('question')?.errors && userForm.get('security')?.get('question')?.touched) {
        <div class="text-danger">
          @if (userForm.get('security')?.get('question')?.hasError('required')) {
            <div>Security Question is required</div>
          }
        </div>
      }
    </div>

    <!-- Security Answer -->
    <div class="form-group" formGroupName="security">
      <label>Security Answer</label>
      <input class="form-control" type="text" formControlName="answer">
      @if (userForm.get('security')?.get('answer')?.errors && userForm.get('security')?.get('answer')?.touched) {
        <div class="text-danger">
          @if (userForm.get('security')?.get('answer')?.hasError('required')) {
            <div>Security Answer is required</div>
          }
        </div>
      }
    </div>

    <h3 class="section-title color-default">Contact Information</h3>

    <!-- Phone Number -->
    <div formGroupName="phones">
      <div class="form-group" formGroupName="0">
        <label>Phone Number</label>
        <input class="form-control" type="tel" formControlName="number">
        @if (userForm.get('phones')?.get('0')?.get('number')?.errors && userForm.get('phones')?.get('0')?.get('number')?.touched) {
          <div class="text-danger">
            @if (userForm.get('phones')?.get('0')?.get('number')?.hasError('required')) {
              <div>Phone Number is required</div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Road -->
    <div class="form-group" formGroupName="address">
      <label>Road</label>
      <input class="form-control" type="text" formControlName="road">
      @if (userForm.get('address')?.get('road')?.errors && userForm.get('address')?.get('road')?.touched) {
        <div class="text-danger">
          @if (userForm.get('address')?.get('road')?.hasError('required')) {
            <div>Road is required</div>
          }
        </div>
      }
    </div>

    <!-- City, State, Zip -->
    <div class="form-group row" formGroupName="address">
      <div class="col-xs-4">
        <label>City</label>
        <input class="form-control" type="text" formControlName="city">
        @if (userForm.get('address')?.get('city')?.errors && userForm.get('address')?.get('city')?.touched) {
          <div class="text-danger">
            @if (userForm.get('address')?.get('city')?.hasError('required')) {
              <div>City is required</div>
            }
          </div>
        }
      </div>
      <div class="col-xs-4">
        <label>State</label>
        <input class="form-control" type="text" formControlName="state">
        @if (userForm.get('address')?.get('state')?.errors && userForm.get('address')?.get('state')?.touched) {
          <div class="text-danger">
            @if (userForm.get('address')?.get('state')?.hasError('required')) {
              <div>State is required</div>
            }
          </div>
        }
      </div>
      <div class="col-xs-4">
        <label>Zip</label>
        <input class="form-control" type="text" formControlName="zip">
        @if (userForm.get('address')?.get('zip')?.errors && userForm.get('address')?.get('zip')?.touched) {
          <div class="text-danger">
            @if (userForm.get('address')?.get('zip')?.hasError('required')) {
              <div>Zip is required</div>
            }
          </div>
        }
      </div>
    </div>

    <h3 class="section-title color-default">Roles</h3>

    <div>
      @for (role of rolesArray; track role) {
        <div>
          <label>
            <input type="checkbox" [value]="role.NAME" (change)="updateRoles($event)" > {{ role.NAME }}
          </label>
        </div>
      }
    </div>

    <div class="form-group">
      <button class="btn btn-default" type="submit">Create User</button>
    </div>
  </form>
</div>
